import React from 'react'
import { useState, useEffect, useCallback, useMemo } from "react";
import { EMPLOYEE_ANALYSIS_REPORT, LEAD_ANALYSIS_REPORT, LEAD_HISTORY_REPORT, LEAD_NEVER_ATTENDED_REPORT, LEAD_NEVER_PICKED_UP_REPORT, LEAD_OVERVIEW_REPORT, NEVER_PICKED_UP_REPORT } from "../../../helpers/url_helper";
import { APIClient } from "../../../helpers/api_helper";
import { formatFlatPickerDates } from "../../../Components/Common/ToCamelCase";
import { Button, Card, CardBody, Col, FormGroup, Label, Row, TabContent } from "reactstrap";
import { DatePicker } from '../../../Components/Common/Flatpicker';
import TeamSelect from '../../../Components/Common/TeamSelect';
import EmployeeSelect from '../../../Components/Common/EmployeeSelect';
import { getPreviousDate, setCurrentDate } from '../../../Components/Common/DefaultDateSet';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { getColumnsByTab, ReportTabPane } from './ReportAnalyticsComponent/ReportTabPane';
import { CustomNavTabs } from '../../../Components/Common/CustomNavTabs';
import { useProfileData } from '../../../Components/Hooks/UserHooks';
import { useNavigate } from 'react-router-dom';
import CalculateRemainingDays from '../../../Components/Common/CalculateRemainingDays';
import SubExpired from '../../../Components/Common/subExpired';
const api = new APIClient();


const initialPagination = { currentPage: 1, perPage: 10 };


const ReportAnalytics = () => {

    // tab Name
    const navItems = [
        { id: "1", label: "Lead Overview" },
        { id: "2", label: "Lead Analytics" },
        { id: "3", label: "Employee Analytics" },
        { id: "4", label: "Lead Call History" },
        { id: "5", label: "Never Attended" },
        { id: "6", label: "Not Pickup by Client" },
    ];

    // default date 
    const previewsDate = getPreviousDate();
    const currentDate = setCurrentDate();

    // date picker state
    const [selectedFromDate, setSelectedFromDate] = useState(previewsDate);
    const [selectedToDate, setSelectedToDate] = useState(currentDate);

    // Memoized formatted dates
    const formattedDates = useMemo(() =>
        formatFlatPickerDates(selectedFromDate, selectedToDate),
        [selectedFromDate, selectedToDate]
    );

    // Memoized date object using formattedDates
    const dateObj = useMemo(() => ({
        startDate: formattedDates.formattedStartDate,
        endDate: formattedDates.formattedEndDate,
    }), [formattedDates]);

    const [EmployeeData, setEmployeeData] = useState([]);
    const [teamIndu, setTeamIndu] = useState([]);

    // employee wise state
    const [selectedEmployeeOptions, setSelectedEmployeeOptions] = useState([]);
    const [selectedEmployeeOptions2, setSelectedEmployeeOptions2] = useState([]);
    const [EmployeeDefaultWithoutTeam, setEmployeeDefaultWithoutTeam] = useState([]);
    const [prevEmployeesIds_Test, setPrevEmployeesIds_Test] = useState([]);

    const [appliedFilters, setAppliedFilters] = useState({
        employeeIds: [],
        dateObj: {
            startDate: formattedDates.formattedStartDate,
            endDate: formattedDates.formattedEndDate
        }
    });
    const [isFirstEffectRun, setIsFirstEffectRun] = useState(false);

    // error message show in not a select empty
    const [error, setError] = useState("");
    const [pagination, setPagination] = useState({
        "1": { currentPage: 1, perPage: 10 },
        "2": { currentPage: 1, perPage: 10 },
        "3": { currentPage: 1, perPage: 10 },
        "4": { currentPage: 1, perPage: 10 },
        "5": { currentPage: 1, perPage: 10 },
        "6": { currentPage: 1, perPage: 10 }
    });

    const [customActiveTab, setCustomActiveTab] = useState("1");
    const [isLoading, setIsLoading] = useState(false);


    const [reportData, setReportData] = useState({
        "1": { data: [], total: 0 },
        "2": { data: [], total: 0 },
        "3": { data: [], total: 0 },
        "4": { data: [], total: 0 },
        "5": { data: [], total: 0 },
        "6": { data: [], total: 0 },
    });


    const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);
    const navigate = useNavigate();
    const { profileData } = useProfileData();
    const remainingDays = CalculateRemainingDays();

    // Form Date function 
    const handleFromDateChange = (dates) => {
        setSelectedFromDate(dates[0]);
    };


    // To Date function 
    const handleToDateChange = (dates) => {
        setSelectedToDate(dates[0]);
    };

    // all apiEndPoints 
    const apiEndpoints = useMemo(() => ({
        "1": LEAD_OVERVIEW_REPORT,
        "2": LEAD_ANALYSIS_REPORT,
        "3": EMPLOYEE_ANALYSIS_REPORT,
        "4": LEAD_HISTORY_REPORT,
        "5": LEAD_NEVER_ATTENDED_REPORT,
        "6": LEAD_NEVER_PICKED_UP_REPORT,
    }), []);

    // Modified to use appliedFilters instead of form state
    const getRequestData = useCallback(() => {
        return {
            employeeIds: appliedFilters.employeeIds,
            startDate: appliedFilters.dateObj.startDate,
            endDate: appliedFilters.dateObj.endDate,
        };
    }, [appliedFilters]);


    // all api fetch data 
    const fetchLeadReport = useCallback(
        async (tab, currentPage, perPage) => {
            if (!apiEndpoints[tab]) return;
            if (!appliedFilters.employeeIds.length) {
                console.warn("Skipping API call: employeeIds is empty.");
                return;
            }
            setIsLoading(true);
            try {
                const requestData = getRequestData();
                if (!requestData.employeeIds.length) {
                    console.error("Error: employeeIds cannot be empty");
                    setIsLoading(false);
                    return;
                }
                let url = apiEndpoints[tab];
                if (tab !== "5") {
                    url = `${url}?pg=${currentPage}&lm=${perPage}`;
                }
                const response = await api.create(url, requestData);
                
                if (tab === "5") {
                    if (response?.success === true) {
                        let tableData = [];
                        const apiResponse = response?.data;
                        const dataArray = (apiResponse?.data) ? apiResponse?.data : [];
                        if (dataArray.length > 0) {
                            const neverAttendData = dataArray[0];
                            tableData = (neverAttendData?.paginatedResults || [])?.map(
                                (data, index) => ({
                                    empDescription: data.empDescription,
                                    leadDetail: data.leadDetail,
                                    dataAndType: data.dataAndType,
                                    attempt: data.attempt,
                                    total: data.total,
                                })
                            );
                        }
                        setReportData((prev) => ({
                            ...prev,
                            [tab]: { data: tableData, total: response.data.totalCount },
                        }));
                    }
                } else {
                    if (response?.success) {
                        setReportData((prev) => ({
                            ...prev,
                            [tab]: { data: response.data.data, total: response.data.totalCount },
                        }));
                    }
                }
            } catch (error) {
                console.error("Error fetching report:", error);
            } finally {
                setIsLoading(false);
            }
        },
        [apiEndpoints, getRequestData]
    );


    const { currentPage, perPage } = pagination[customActiveTab] || initialPagination;

    // default data show in DataTable
    useEffect(() => {
        // Only run this effect when there are applied filters
        if (appliedFilters.employeeIds.length > 0) {
            fetchLeadReport(customActiveTab, currentPage, perPage);
        } else if (!isFirstEffectRun && selectedEmployeeOptions?.length > 0) {
            // Initial load logic - set default applied filters
            let initialEmployeeIds = prevEmployeesIds_Test.length > 0 
                ? prevEmployeesIds_Test 
                : teamIndu.length > 0 
                    ? selectedEmployeeOptions2?.map((option) => option?.id) || []
                    : EmployeeDefaultWithoutTeam?.map((option) => option?.id) || [];
            
            if (initialEmployeeIds.length > 0) {
                setAppliedFilters({
                    employeeIds: initialEmployeeIds,
                    dateObj: {
                        startDate: formattedDates.formattedStartDate,
                        endDate: formattedDates.formattedEndDate
                    }
                });
                setPrevEmployeesIds_Test(initialEmployeeIds);
            }
            setIsFirstEffectRun(true);
        }


    }, [appliedFilters, customActiveTab, currentPage, perPage, isFirstEffectRun]);

    // page change
    const handlePageChange = (page, tabId) => {
        setPagination((prev) => ({
            ...prev,
            [tabId]: {
                ...prev[tabId],
                currentPage: page
            }
        }));
        fetchLeadReport(tabId, page, pagination[tabId]?.perPage);
    };


    // row change in page
    const handlePerRowsChange = (tab, perPage) => {
        setPagination((prev) => ({
            ...prev,
            [tab]: { ...prev[tab], currentPage: 1, perPage },
        }));
        fetchLeadReport(tab, 1, perPage);
    };



    // Switch tab and reset pagination
    const toggleCustom = (tab) => {
        setCustomActiveTab(tab);

        // Reset pagination when switching tabs
        setPagination((prev) => ({
            ...prev,
            [tab]: { ...prev[tab], currentPage: 1 }
        }));
        fetchLeadReport(tab, 1, pagination[tab]?.perPage);
    };


    // Lead List Table data Submit data - now updates appliedFilters
    const handleApplySubmit = async () => {
        if (selectedEmployeeOptions.length === 0) {
            setError("You must select at least one");
        }
        else {
            let updatedIds = selectedEmployeeOptions.map((userid) => userid?.id);
            // Update the applied filters
            setAppliedFilters({
                employeeIds: updatedIds,
                dateObj: {
                    startDate: formattedDates.formattedStartDate,
                    endDate: formattedDates.formattedEndDate
                }
            });
            setError("");
            // Reset pagination when applying new filters
            setPagination(prev => ({
                ...prev,
                [customActiveTab]: { ...prev[customActiveTab], currentPage: 1 }
            }));
        }
    };

    const handleReset = () => {
        setSelectedFromDate(previewsDate);
        setSelectedToDate(currentDate);
        setSelectedEmployeeOptions([]);
        setSelectedEmployeeOptions2([]);
        setTeamIndu([]);
        setError("");
    };

    const handleClose = () => {
        setIsExpiredModalOpen(false);
        navigate("/planPackage");
      };


    return (
        <>
         {remainingDays === 0 && isExpiredModalOpen && (
                    <SubExpired
                        onClose={handleClose}
                        profileData={profileData?.selectedPlanDetails?.planName}
                        remainingDays={remainingDays}
                    />
             )}
            <div className="page-content">
                <div className="container-fluid">
                    {/* Title */}
                    <Col sm={12}>
                        <BreadCrumb title="Report & Analytics" pageTitle="Report & Analytics" />
                    </Col>

                    <Row>
                        <Col xxl={12}>
                            <Card>
                                <CardBody>
                                    <div className="sn-report-lead-tabs">
                                        <Row className="sn-header-select-employess-home sn-team-managment-tble sn-top-inputs-heading">
                                            <Col sm={2}>
                                                <DatePicker
                                                    labelContent="From Date"
                                                    getDate={selectedFromDate}
                                                    options={{
                                                        disable: [
                                                            {
                                                                from: new Date(),
                                                            },
                                                        ],
                                                        dateFormat: "d M, Y",
                                                        maxDate: new Date(
                                                            new Date().setDate(new Date().getDate())
                                                        ),
                                                    }}
                                                    onChange={handleFromDateChange}
                                                />
                                            </Col>

                                            <Col sm={2}>
                                                <DatePicker
                                                    labelContent="To Date"
                                                    getDate={selectedToDate}
                                                    options={{
                                                        disable: [
                                                            {
                                                                from: new Date(),
                                                            },
                                                        ],
                                                        dateFormat: "d M, Y",
                                                        maxDate: new Date(
                                                            new Date().setDate(new Date().getDate())
                                                        ),
                                                    }}

                                                    onChange={handleToDateChange}
                                                />
                                            </Col>

                                            <Col sm={3}>
                                                <div className="mb-3">
                                                    <TeamSelect
                                                        setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                                                        teamIndu={teamIndu}
                                                        setTeamIndu={setTeamIndu}
                                                        labelContent="Select Team"
                                                    />
                                                </div>
                                            </Col>

                                            <Col sm={3}>
                                                <div className="mb-3">
                                                    <EmployeeSelect
                                                        setEmployeeDefaultWithoutTeam={setEmployeeDefaultWithoutTeam}
                                                        EmployeeDefaultWithoutTeam={EmployeeDefaultWithoutTeam}
                                                        error={error}
                                                        setError={setError}
                                                        EmployeeDefault={teamIndu.length === 0 ? EmployeeDefaultWithoutTeam : EmployeeData}
                                                        setEmployeeDefault={setEmployeeData}
                                                        teamIndu={teamIndu}
                                                        selectedEmployeeOptions={selectedEmployeeOptions}
                                                        setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                                                        setSelectedEmployeeOptions2={setSelectedEmployeeOptions2}
                                                        labelContent="Select Employee"
                                                    />
                                                </div>
                                            </Col>

                                            <Col sm={2}>
                                                <FormGroup>
                                                    <Label for="exampleSelect"></Label>
                                                    <div id="exampleSelect" className="sn-call-apply-btn-reset mt-2">
                                                        <Button
                                                            id="exampleSelect"
                                                            type="submit"
                                                            color="danger"
                                                            className=""
                                                            onClick={handleApplySubmit}
                                                        // disabled={isLoading}
                                                        >
                                                            Apply
                                                        </Button>
                                                        <Button
                                                            className=""
                                                            style={{
                                                                marginLeft: "10px",
                                                            }}
                                                            id="exampleSelect"
                                                            outline
                                                            color="danger"
                                                            onClick={handleReset}
                                                        >
                                                            Reset
                                                        </Button>
                                                    </div>
                                                </FormGroup>
                                            </Col>

                                        </Row>
                                    </div>
                                    <div>
                                        <div className="sn-bulk-reportanal-tble sn-storage-tble-top w-100">
                                            <div className="sn-report-lead-tabs">
                                                <CardBody className="pt-0">
                                                    <p className="text-muted">Use class to create custom tabs with borders.</p>
                                                    <CustomNavTabs activeTab={customActiveTab} onTabChange={toggleCustom} navItems={navItems} />
                                                    <TabContent activeTab={customActiveTab} className="text-muted">
                                                        {/* Lead Overview Table */}
                                                        <TabContent activeTab={customActiveTab} className="text-muted">
                                                            {Object.keys(apiEndpoints).map((tabId) => (
                                                                <ReportTabPane
                                                                    customActiveTab={customActiveTab}
                                                                    key={tabId}
                                                                    tabId={tabId}
                                                                    columns={getColumnsByTab(tabId, navigate)}
                                                                    data={reportData[tabId]?.data}
                                                                    totalRows={reportData[tabId]?.total}
                                                                    pagination={pagination[tabId] || { currentPage: 1, perPage: 10 }} // Fallback value
                                                                    onPageChange={handlePageChange}
                                                                    onPerRowsChange={handlePerRowsChange}
                                                                    isLoading={isLoading}
                                                                />
                                                            ))}
                                                        </TabContent>
                                                    </TabContent>
                                                </CardBody>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default ReportAnalytics;